import { ComponentProps } from 'react';

import {
  Assets,
  Box,
  Container,
  Flex,
  ForaDatePicker,
  Text,
  theme,
  TooltipAriakit,
  useMediaMax,
} from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../../i18n/i18n';
import { datePickerWidth } from './constants';
import { useAppSelector } from '../../../redux/hooks';

export const ParameterDateInputFields = ({
  startDateInputProps,
  endDateInputProps,
  activeParameterName,
  disabled,
}: {
  startDateInputProps?: ComponentProps<typeof ForaDatePicker>;
  endDateInputProps?: ComponentProps<typeof ForaDatePicker>;
  activeParameterName?: string;
  disabled?: boolean;
}) => {
  const { ffChangeParameterEndDate } = useAppSelector(state => state.foraGlobal.settings);
  // 170954: Remove all code related to disableParameterEndDateForTGL1 when featureflag is removed
  const disableParameterEndDateForTGL1 = ffChangeParameterEndDate ? false : !!activeParameterName;
  const isMobile = useMediaMax(theme.breakpoint.md);
  const { t } = useTypedTranslation();

  return (
    <Container marginTop={20} marginBottom={30}>
      {activeParameterName && <Text marginBottom={20}>{activeParameterName}</Text>}
      <Flex
        columnGap={10}
        rowGap={10}
        flexDirection={['column', 'column', 'row']}
        alignItems={['flex-start', 'flex-start', 'center']}
      >
        {startDateInputProps && (
          <ForaDatePicker
            {...startDateInputProps}
            label={t('common.startDate')}
            disabled={disabled}
            width={['100%', '100%', datePickerWidth[endDateInputProps ? 'short' : 'default']]}
          />
        )}
        {endDateInputProps && (
          <>
            {startDateInputProps && (
              <Assets.FatArrowIcon rotate={isMobile ? 0 : -90} width={20} color={disabled ? 'black50' : undefined} />
            )}
            <TooltipAriakit
              content={
                <Box>
                  <Text fontWeight="bold">{t('tooltips.employment.parameterEndDateLocked.title')} </Text>
                  <Text>{t('tooltips.employment.parameterEndDateLocked.description')} </Text>
                </Box>
              }
              id={'tooltip-markup-start-date'}
              conditionalTooltip={disableParameterEndDateForTGL1}
            >
              <ForaDatePicker
                {...endDateInputProps}
                label={`${disableParameterEndDateForTGL1 ? '' : '*'}${t('common.endDate')}`}
                disabled={disabled || disableParameterEndDateForTGL1}
                useUntilFurtherNotice={true}
                width={['100%', '100%', datePickerWidth[startDateInputProps ? 'short' : 'default']]}
              />
            </TooltipAriakit>
          </>
        )}
      </Flex>
      {disableParameterEndDateForTGL1 && (
        <Text marginTop={20} color="black70">
          {t('list.markupAndParametersList.changeEndDateHelpText')}
        </Text>
      )}
    </Container>
  );
};
